import * as React from 'react';
import { RenderComp } from '../core/render-comp.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { FormFieldContext } from './form.context.js';

const FormField = renderWithRef('FormField', undefined, (props, ref)=>{
    const [inputId, setInputId] = React.useState(undefined);
    const [helperIds, setHelperIds] = React.useState(new Set());
    const [errorIds, setErrorIds] = React.useState(new Set());
    return /*#__PURE__*/ React.createElement(FormFieldContext.Provider, {
        value: {
            inputId,
            setInputId,
            helperIds,
            setHelperIds,
            errorIds,
            setErrorIds
        }
    }, /*#__PURE__*/ React.createElement(RenderComp, {
        root: "div",
        forwardedRef: ref,
        props: props
    }, props.children));
});

export { FormField };
